/**
 * Function to find the intersection between two arrays
 *
 * @template T
 * @param {T[]} array1
 * @param {T[]} array2
 *
 * @example
 * intersection([1, 2, 3], [1], [1]);
 * // return [1]
 * @example
 * intersection([1, 2, 4, 7], [4, 6, 7]);
 * // return [4, 7]
 *
 * @return {*}  {T[]}
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
export var intersection = function (array1, array2) {
    var arr1;
    var arr2;
    // reducing the number of iterations on long arrays
    if (array1.length > array2.length) {
        (arr1 = array1);
        (arr2 = array2);
    }
    else {
        (arr1 = array2);
        (arr2 = array1);
    }
    var uniqArr2 = __spread(new Set(arr2));
    return uniqArr2.reduce(function (acc, item) { return (arr1.includes(item) ? __spread(acc, [item]) : acc); }, []);
};
//# sourceMappingURL=intersection.js.map